<template>
  <div class="ac ">
    <TopHead name="专题活动" />
    <div class="ac_con">
    <!--列表-->
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="(item, index) in list" :key="index" class="list_item_ta" @click="gotoInner(item)">
          <van-image fit="cover" :src="item.coverImageUrl">
            <template #loading>
              <img src="../assets/img/img_loading.png" alt="">
            </template>
          </van-image>
          <div class="li_ta">
           {{ item.title }}
          </div>
          <div class="li_tags" :class="item.activityStatus == 1?'li_tagsOld':''">
           {{ item.activityStatusStr }}
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div></div>
</template>
<script>
export default {
  name: 'ThematicActivities',
  data () {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      list: [],
      params: {
        pageIndex: 1,
        pageSize: 10,
      },
      isPending: true,
    }
  },
  methods: {
    listLoad () {
      this.loading = true;
      if (!this.isPending) return;
      this.isPending = false;
      this.$api.getinformationActivityTopicList(this.params).then(res => {
        this.loading = false;
        this.isPending = true;
        if (this.refreshing) {
          this.refreshing = false;
        }
        if (res.data.recordCount) {
          this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
        }
        let list = res.data.rows;
        if (!list || list.length < this.params.pageSize) {
          this.finished = true;
        }
      })

    },
    onRefresh () {
      this.list = [];
      this.finished = false;
      this.params.pageIndex = 1;
      this.listLoad();
    },
    onLoad () {
      let me = this;
      if (!this.isPending) return;
      let page = me.params.pageIndex;
      page = page ? page + 1 : 1;
      this.params.pageIndex = page;
      this.listLoad();
    },
    gotoInner (row) {
        this.$router.push('/ThematicActivitiesList?activityTopicId='+row.id)
   
    },
  },
  created () {
    this.listLoad();
  },
  mounted () {
  },
}
</script>
<style lang="scss" scoped>
.ac {
  padding-top: 85px;
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
}
  .ac_con {
  padding: 0 25px 25px;
}
  .list_item_ta {

    width: 100%;
    height: 380px;
    margin-bottom: 24px;
    border-radius: 20px;
    position: relative;

  }
  .van-image{
    border-radius: 20px;
    img{
    border-radius: 20px;

    }
  }

  .li_ta {
    padding: 18px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: rgba($color: #000000, $alpha: 0.5);
    border-radius: 0px 0px 20px 20px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 38px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .li_tags{
    min-width: 130px;
    position: absolute;
    text-align: center;
    top: 0;
    left: 0;
    font-size: 20px;
    padding: 18px;
    box-sizing: border-box;
    color: #FFFFFF;
    background: #2c93e2;
  }
  .li_tagsOld{
    background: #c0c0c0;
    color: #3e3e3e;

  }
</style>
